import { registerSolidJSComponents, registerKnockoutComponents } from '../index';

registerSolidJSComponents(import.meta.glob('./components/**/*.{jsx,tsx}'));
registerKnockoutComponents(import.meta.glob('./components/**/*.{ts}'));
